module.exports = "<p>\r\n  ag-select-action-cell-renderer works!\r\n</p>\r\n"